import React, { useState, useEffect } from 'react';

interface StreamTextProps {
  text: string;
  speed?: number;
  delay?: number;
  onDone?: () => void;
  caret?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export const StreamText: React.FC<StreamTextProps> = ({
  text,
  speed = 28,
  delay = 0,
  onDone,
  caret = true,
  style,
  className,
}) => {
  const [shown, setShown] = useState('');

  useEffect(() => {
    let i = 0;
    let mounted = true;
    
    // Reset shown text when input text changes
    setShown('');
    
    const start = setTimeout(() => {
      const id = setInterval(() => {
        if (!mounted) return;
        i++;
        setShown(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(id);
          if (onDone) onDone();
        }
      }, speed);
    }, delay);

    return () => {
      mounted = false;
      clearTimeout(start);
    };
  }, [text, speed, delay, onDone]);

  const done = shown.length === text.length;

  return (
    <span style={style} className={className}>
      {shown}
      {caret && !done && <span className="om-caret">▍</span>}
    </span>
  );
};

export default StreamText;
